import { authGet, authGetConditional, authPost, type ConditionalResponse } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type {
  ClaimWinStreakTowerFloorResponse,
  WinStreakTowerPayloadDto,
} from "../dto/win_streak_tower.dto.js";

const WIN_STREAK_TOWER_PATH = "api/player/me/win-streak-tower?include_locked=1";

export function getWinStreakTower(): Promise<WinStreakTowerPayloadDto>
{
  const primed = PrimedResponses.take<WinStreakTowerPayloadDto>( "win_streak_tower" );
  if ( primed ) return Promise.resolve( primed );
  return authGet<WinStreakTowerPayloadDto>( WIN_STREAK_TOWER_PATH );
}

export function getWinStreakTowerConditional( etag: string | null ): Promise<ConditionalResponse<WinStreakTowerPayloadDto>>
{
  const primed = PrimedResponses.take<WinStreakTowerPayloadDto>( "win_streak_tower" );
  if ( primed )
    return Promise.resolve( { status: 200, data: primed, etag: PrimedResponses.take<string | null>( "win_streak_tower_etag" ) ?? null } );
  return authGetConditional<WinStreakTowerPayloadDto>( WIN_STREAK_TOWER_PATH, etag );
}

export function resetWinStreakTowerProgress(): Promise<{ ok: true; deleted: number }>
{
  return authPost<{ ok: true; deleted: number }>(
    "api/player/me/win-streak-tower/reset-progress",
    { confirm: true }
  );
}

export function claimWinStreakTowerFloor(
  floor_id: number
): Promise<ClaimWinStreakTowerFloorResponse>
{
  return authPost<ClaimWinStreakTowerFloorResponse>(
    `api/player/me/win-streak-tower/floors/${floor_id}/claim`
  );
}
